export default __webpack_public_path__ + "static/media/8.9cc89d25.jpeg";